// extracted by mini-css-extract-plugin
export default {"wrapper":"P0-z","play":"Q0-z"};